module.exports = __webpack_public_path__ + "static/media/arrow-up.25a6333b.svg";